import { Label } from "@EditArticleContainer/shared/components/EditableTextContainer/types/editableText.types";
import { RightsScopeTableItem } from "@EditArticleContainer/shared/types/paragraphContents/contents/keyRightsLASCContent.types";
import { createMultiLineText } from "@utils/createMultiLineText/createMultiLineText";

const toLabels = (labels: unknown): Label[] => (labels ?? []) as Label[];

export const assetText = (item: RightsScopeTableItem) =>
  createMultiLineText({
    textList: item.Asset.value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const assetLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item.Asset.value.at(0)?.labels);

export const rightsTypeText = (item: RightsScopeTableItem) =>
  item["Rights Scope Type"].value.at(0)?.text ?? "";

export const rightsTypeLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item["Rights Scope Type"].value.at(0)?.labels);

export const rightsScopeText = (item: RightsScopeTableItem) =>
  createMultiLineText({
    textList: item["Rights Scope"].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const rightsScopeLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item["Rights Scope"].value.at(0)?.labels);

export const rightsLimitationText = (item: RightsScopeTableItem) =>
  createMultiLineText({
    textList: item["Rights Limitation"].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const rightsLimitationLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item["Rights Limitation"].value.at(0)?.labels);

export const intendedUseText = (item: RightsScopeTableItem) =>
  createMultiLineText({
    textList: item["Intended Use"].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const intendedUseLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item["Intended Use"].value.at(0)?.labels);

export const exclusivityText = (item: RightsScopeTableItem) =>
  item.Exclusivity.value.at(0)?.text ?? "";

export const exclusivityLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item.Exclusivity.value.at(0)?.labels);

export const territoryText = (item: RightsScopeTableItem) =>
  createMultiLineText({
    textList: item.Territory.value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const territoryLabels = (item: RightsScopeTableItem): Label[] =>
  toLabels(item.Territory.value.at(0)?.labels);

export const contributingAxisValues = (item: RightsScopeTableItem): string[] =>
  item["Rights Flow"]["Contributing Axis"].value.map((v) => v.text ?? "");

export const benefitingAxisValues = (item: RightsScopeTableItem): string[] =>
  item["Rights Flow"]["Benefiting Axis"].value.map((v) => v.text ?? "");
